// src/filter/registry.ts
import type { FilterKey, Option } from "@/filter";
import { DataPaginate } from "@/types";

export type SourceKind =
  | { type: "static"; data: Option[] }
  | { type: "endpoint"; url: string; map?: (raw: any) => Option[] }
  | {
      type: "loader";
      load: (ctx?: { signal?: AbortSignal; q?: string }) => Promise<Option[]>;
    };

export type FilterRegistry = Record<FilterKey, SourceKind>;

export const defaultFilterRegistry: FilterRegistry = {
  kategoriSurat: {
    type: "endpoint",
    url: "configuration/letter-type?limit=9999",
    map: (data: DataPaginate<CategoryResonse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  sifatSurat: {
    type: "endpoint",
    url: "configuration/letter-character?limit=9999",
    map: (data: DataPaginate<NatureResponse>) => [
      { label: "Semua", value: "" },
      ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
    ],
  },
  disposisi: {
    type: "static",
    data: [
      { label: "Iya", value: "true" },
      { label: "Tidak", value: "false" },
    ],
  },
  statusSurat: {
    type: "static",
    data: [
      { label: "Semua", value: "" },
      { label: "Dibaca", value: "true" },
      { label: "Belum Dibaca", value: "false" },
    ],
  },
  statusVerifikator: {
    type: "static",
    data: [
      { label: "Belum Diverifikasi", value: "pending" },
      { label: "Disetujui", value: "approved" },
      { label: "Ditolak", value: "rejected" },
    ],
  },
  statusPenandatanganan: {
    type: "static",
    data: [
      { label: "Belum TTD", value: "not_signed" },
      { label: "Sudah TTD", value: "signed" },
    ],
  },
  statusKirim: {
    type: "static",
    data: [
      { label: "Belum Dikirim", value: "not_sent" },
      { label: "Sudah Dikirim", value: "sent" },
    ],
  },
};
